import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

const linkBase =
  "text-black no-underline text-base px-2.5 py-1.5 rounded hover:bg-[#DD7C88]";
const active =
  "bg-[#DD7C88]"; // style quand la route est active (NavLink)

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white text-black py-5 px-5">
      <div className="flex justify-between items-center">
        <h1 className="text-[28px] m-0 font-bold">
          <Link to="/" className="no-underline text-black">SAUBENS 31</Link>
        </h1>

        {/* Burger mobile */}
        <button
          onClick={() => setIsMenuOpen((v) => !v)}
          className="md:hidden p-2"
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <div className="w-6 h-0.5 bg-black mb-1.5"></div>
          <div className="w-6 h-0.5 bg-black mb-1.5"></div>
          <div className="w-6 h-0.5 bg-black"></div>
        </button>

        {/* Desktop */}
        <nav className="hidden md:block">
          <ul className="list-none m-0 p-0 flex items-center">
            <li className="ml-5">
              <NavLink to="/" end className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}>
                Accueil
              </NavLink>
            </li>
            <li className="ml-5">
              <NavLink to="/club" className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}>
                Le Club
              </NavLink>
            </li>
            <li className="ml-5">
              <NavLink to="/evenement" className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}>
                Evenement
              </NavLink>
            </li>
            <li className="ml-5">
              <NavLink to="/saubenoise" className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}>
                Saubenoise
              </NavLink>
            </li>
            <li className="ml-5">
              <NavLink to="/contact" className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}>
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>

      {/* Mobile */}
      <nav className={`${isMenuOpen ? "block" : "hidden"} md:hidden mt-4`}>
        <ul className="list-none m-0 p-0 flex flex-col">
            {[
              { to: "/", label: "Accueil", end: true },
              { to: "/club", label: "Le Club" },
              { to: "/evenement", label: "Evenement" },
              { to: "/saubenoise", label: "Saubenoise" },
              { to: "/contact", label: "Contact" },
            ].map(({ to, label, end }) => (
            <li key={to} className="mb-2">
              <NavLink
                to={to}
                end={end}
                className={({ isActive }) => `block ${linkBase} ${isActive ? active : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
